import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from 'src/app/backend-client/api-configuration';
import {
  AdminIssueReportListRequest,
  AdminIssueReportListResponse,
  CreateIssueReportRequest,
  CreateIssueReportResponse,
  IssueReportAttachmentDto,
  IssueReportDto,
  IssueReportListResponse,
  SetIssueReportStateRequest,
} from 'src/app/backend-client/models/Backend/Core/Api/Models/App/IssueReport/issue-report-models';
import { AppIssueReportBackendService } from 'src/app/backend-client/services';

/** Csatolmány-korlátok (a szerverrel egyezően): jpeg/png/webp/pdf, legfeljebb 5 MB, bejelentésenként 3 fájl. */
export const ISSUE_ATTACHMENT_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
export const ISSUE_ATTACHMENT_MAX_BYTES = 5 * 1024 * 1024;
export const ISSUE_ATTACHMENT_MAX_COUNT = 3;
export const ISSUE_TITLE_MAX = 120;
export const ISSUE_DESCRIPTION_MAX = 4000;

/** Hibajelzés: a patikák a portál és a Szirom Pont app hibáit jelentik be, az admin állapotot állít. */
@Injectable({ providedIn: 'root' })
export class AppIssueReportService {
  constructor(
    private backend: AppIssueReportBackendService,
    private http: HttpClient,
    private apiConfiguration: ApiConfiguration
  ) {}

  // --- patika ---

  create(input: CreateIssueReportRequest): Observable<CreateIssueReportResponse> {
    return this.backend.createIssueReport$Json({ body: input });
  }

  /** Egy csatolmány feltöltése a már létrehozott bejelentéshez (multipart: id, file). */
  uploadAttachment(id: number, file: File): Observable<IssueReportAttachmentDto> {
    const formData = new FormData();
    formData.append('id', String(id));
    formData.append('file', file, file.name);
    return this.http.post<IssueReportAttachmentDto>(`${this.apiConfiguration.rootUrl}${AppIssueReportBackendService.UploadAttachmentPath}`, formData);
  }

  list(): Observable<IssueReportListResponse> {
    return this.backend.listIssueReports$Json({ body: {} });
  }

  get(id: number): Observable<IssueReportDto> {
    return this.backend.getIssueReport$Json({ body: { id } });
  }

  /** A csatolmány tartalma blobként (auth fejléccel megy, mint a többi letöltés). */
  downloadAttachment(attachmentId: number): Observable<Blob> {
    return this.http.get(`${this.apiConfiguration.rootUrl}${AppIssueReportBackendService.AttachmentPath}/${attachmentId}`, { responseType: 'blob' });
  }

  // --- admin ---

  adminList(input: AdminIssueReportListRequest): Observable<AdminIssueReportListResponse> {
    return this.backend.adminListIssueReports$Json({ body: input });
  }

  adminSetState(input: SetIssueReportStateRequest): Observable<IssueReportDto> {
    return this.backend.adminSetIssueReportState$Json({ body: input });
  }
}
